import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
export function OutcomesSection() {
  const outcomes = ['Más claridad sobre tu camino', 'Un plan real para avanzar', 'Dirección estratégica', 'Más seguridad para mostrarte', 'Orden en tu contenido y mensaje', 'Herramientas para conectar y vender', 'Una visión más clara de tu negocio digital'];
  return <section className="py-24 px-6 max-w-4xl mx-auto text-center" data-id="element-83">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} data-id="element-84">
        <h2 className="text-3xl md:text-4xl font-serif text-brand-cream mb-4 flex items-center justify-center gap-3" data-id="element-85">
          <span className="text-brand-gold text-2xl" data-id="element-86">✨</span>
          Lo que vas a lograr
        </h2>
        <p className="text-lg text-brand-cream/70 font-light mb-12" data-id="element-87">
          Después de esta mentoría tendrás:
        </p>

        <div className="flex flex-col gap-6 max-w-2xl mx-auto" data-id="element-88">
          {outcomes.map((outcome, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-brand-brown-light/60 p-6 border border-brand-gold/25 shadow-md rounded-lg flex items-center justify-center gap-4" data-id="element-89">
              <Heart className="w-6 h-6 text-brand-gold-light" fill="#E6CFA0" style={{
            filter: 'drop-shadow(0 0 6px rgba(230, 207, 160, 0.7)) drop-shadow(0 0 2px rgba(201, 168, 118, 0.9))'
          }} data-id="element-90" />
              <span className="text-brand-cream text-lg font-medium" data-id="element-91">
                {outcome}
              </span>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}